import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import settings from "@/settings";
import router from "../router";
import ProductStore from "./store-product";
import UserStore from "./store-user";
import SalesInvoiceStore from "./store-sales-invoice";
import ShopsMapStore from "./store-shops-map";
import ShopsAdminStore from "./store-shops-admin";
import ExportSaleInvoiceStore from "./store-export-sale-invoice";
import ExportClientStore from "./store-export-client";
import ClientStore from "./store-client";
import UnmatchedShopsStore from "./store-unmatched-shops";
import LogStore from "./store-log";
import SearchHistoryStore from "./store-search-history.js";
import NotificationCenterStore from "./store-notification-center.js";
import RuleStore from "./store-rule.js";
import WorkOrderStore from "./store-work-order.js";
import ExtProductStore from "./store-ext-product.js";
import CampaignStore from "./store-campaign.js";
import AnalysisStore from "./store-analysis.js";
import ShipmentStore from "./store-shipment.js";
import ProductionAnalysisStore from "./store-production-analysis.js";
import PublicShipmentStore from "./store-public-shipment.js";
import TagStore from "./store-tag.js";
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        ProductStore,
        UserStore,
        SalesInvoiceStore,
        ShopsMapStore,
        ShopsAdminStore,
        ExportSaleInvoiceStore,
        ExportClientStore,
        ClientStore,
        UnmatchedShopsStore,
        LogStore,
        SearchHistoryStore,
        NotificationCenterStore,
        RuleStore,
        WorkOrderStore,
        ExtProductStore,
        CampaignStore,
        AnalysisStore,
        ShipmentStore,
        ProductionAnalysisStore,
        PublicShipmentStore,
        TagStore
    },
    state: {
        is_logged_in: (window.app.pageData && window.app.pageData.is_logged_in) || false,
        translations: {},
        iframe_modal: false,
        iframe_info: {
            title: null,
            url: null
        },
        user: {
            id: window.app.pageData.user_id,
            first_name: window.app.pageData.first_name,
            email: null,
            password: null,
            error: false,
            custom_links: null,
            permissions: {},
            locale:"en"
        },
        registration: {
            company_name: null,
            company_regCode: null,
            company_address: null,
            company_country: null,
            user_email: null,
            user_password: null,
            user_repeated_password: null,
            user_firstname: null,
            user_lastname: null,
            user_locale: null,
            error: ""
        },
        countries: [],
        products: [],
        clients: [],
        clients_all: [],
        export_clients: [],
        users: [],
        shops: [],
        stores: [],
        tags: [],
    },
    actions: {
        async getUserData({commit}) {
            try {
                const response = await axios.get(settings.api_url + "/login");
                const data = response.data;
                if (response.status === 200 && data.success === 1) {
                    commit("setIsLoggedIn", true);
                    commit("setUserData", response.data);
                } else {
                    commit("updateUserProperty", {prop: "error", value: true});
                    router.push("/login");
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", {prop: "error", value: true});
            }
        },
        async login({commit}, payload) {
            commit("updateUserProperty", {prop: "error", value: false});
            try {
                const response = await axios.post(settings.api_url + "/login", {
                    email: payload.email.trim(),
                    password: payload.password.trim()
                });
                const data = response.data;
                if (response.status === 200 && data.success === 1) {
                    commit("setIsLoggedIn", true);
                    commit("setUserData", response.data);
                    router.push("/");
                } else {
                    commit("updateUserProperty", {prop: "error", value: true});
                }
            } catch (e) {
                console.error("- ERROR -");
                console.error(e);
                commit("updateUserProperty", {prop: "error", value: true});
            }
        },
        async logout({commit, state}, directToLogin) {
            try {
                commit("setUserData", {
                    id: null,
                    first_name: null,
                    email: null,
                    password: null,
                    error: false,
                    custom_links: null,
                    permissions: {}
                });
                if (state.is_logged_in) {
                    await axios.delete(settings.api_url + "/logout/");
                }
                commit("setIsLoggedIn", false);
                window.localStorage.clear();
                if (directToLogin) await router.push("/login");
            } catch (e) {
                console.log(e);
            }
        },
        async resetPassword({commit}, payload) {
            commit("updateUserProperty", {prop: "error", value: false});
            try {
                const response = await axios.post(settings.api_url + "/reset-password/", {
                    email: payload.email.trim()
                });
                const data = response.data;
                if (data.success === 0) {
                    commit("updateUserProperty", {prop: "error", value: true});
                }
                return data;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", {prop: "error", value: true});
            }
        },
        async checkHashValidity({commit, state}, payload) {
            try {
                const response = await axios.post(settings.api_url + "/check-hash/", {
                    email: payload.email.trim(),
                    hash: payload.hash.trim()
                });
                const data = response.data;
                return data;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", {prop: "error", value: true});
            }
        },
        async changeUserPassword({commit, state}, payload) {
            try {
                const response = await axios.post(settings.api_url + "/change-password/", {
                    email: payload.email.trim(),
                    hash: payload.hash.trim(),
                    password: payload.password.trim()
                });
                return response.data;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", {prop: "error", value: true});
            }
        },
        async fetchTranslations({commit}, locale) {
            try {
                let url = settings.assets_url + "/static/translations/" + locale + ".json";
                let results = await axios.get(url, {withCredentials: false});
                commit("addTranslations", {
                    translations: results.data
                });
            } catch (e) {
                console.log("- TRANSLATION FETCH ERROR -");
                console.log(e);
            }
        },
        async checkActivationValidity({commit, state}, payload) {
            try {
                let data = {
                    email: payload.email.trim(),
                    hash: payload.hash.trim(),
                    pw: payload.pw,
                    type: payload.type
                };
                const response = await axios.post(settings.api_url + "/activation/", data);
                return response.data;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", {prop: "error", value: true});
            }
        },
        async registerUserAndCompany({commit, state}, payload) {
            try {
                const response = await axios.post(settings.api_url + "/register/", payload);
                return response.data;
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("updateUserProperty", {prop: "error", value: true});
            }
        },
        async fetchCountries({commit}) {
            try {
                let result = await axios.get(settings.api_url + "/countries/");
                if (result && result.data && result.data.success === 1) {
                    commit("addCountries", result.data.countries);
                }
            } catch (e) {
                console.log("- COUNTRIES FETCH ERROR -");
                console.log(e);
            }
        },
        async getFrequentlyUsedQueries({commit}, params) {
            try {
                let result = await axios.get(settings.api_url + "/frequently-used-queries/", {params});
                if (result && result.data && result.data.success === 1) {
                    let data = result.data;
                    if (data.clients) {
                        commit("addClients", data.clients);
                    }
                    if (data.clients_all) {
                        commit("addClientsAll", data.clients_all);
                    }
                    if (data.export_clients) {
                        commit("addExportClients", data.export_clients);
                    }
                    if (data.products) {
                        commit("addProducts", data.products);
                    }
                    if (data.users) {
                        commit("addUsers", data.users);
                    }
                    if (data.shops) {
                        commit("addShops", data.shops);
                    }
                    if (data.stores) {
                        commit("addStores", data.stores);
                    }
                    if (data.tags) {
                        commit("addTags", data.tags);
                    }
                    if (data.countries) {
                        commit("addCountries", data.countries);
                    }
                    if (data.categories) {
                        commit("addCategories", data.categories);
                    }
                    if (data.brands) {
                        commit("addBrands", data.brands);
                    }
                }
            } catch (e) {
                console.log("- COUNTRIES FETCH ERROR -");
                console.log(e);
            }
        }
    },
    mutations: {
        addTranslations(state, args) {
            state.translations = args.translations;
        },
        updateUserProperty(state, {prop, value}) {
            state.user = {
                ...state.user,
                [prop]: value
            };
        },
        setIsLoggedIn(state, bool) {
            state.is_logged_in = bool;
        },
        setUserData(state, user_data) {
            state.user.id = user_data.id;
            state.user.first_name = user_data.first_name;
            state.user.custom_links = user_data.custom_links;
            state.user.role = user_data.role;
            state.user.work_roles = user_data.work_roles;
            state.user.permissions = user_data.permissions;
            state.user.locale = user_data.locale;
        },
        updateRegistrationProperty(state, {prop, value}) {
            state.registration = {
                ...state.registration,
                [prop]: value
            };
        },
        toggleIframeModal(state, bool) {
            state.iframe_modal = bool;
        },
        setIframeModalInfo(state, {prop, value}) {
            state.iframe_info = {
                ...state.iframe_info,
                [prop]: value
            };
        },
        setUserCustomLinksData(state, value) {
            state.user.custom_links = value;
        },
        addCountries(state, value) {
            // Pre-compute display_name once for autocomplete performance
            state.countries = value.map(c => ({
                ...c,
                display_name: (c.name_et || c.name_en) + ' (' + c.code + ')'
            }));
        },
        addCategories(state, value) {
            state.categories = value;
        },
        addBrands(state, value) {
            state.brands = value;
        },
        addClients(state, clients) {
            state.clients = clients;
        },
        addClientsAll(state, clients_all) {
            state.clients_all = clients_all;
        },
        addExportClients(state, export_clients) {
            state.export_clients = export_clients;
        },
        addProducts(state, products) {
            state.products = products;
        },
        addUsers(state, users) {
            state.users = users;
        },
        addShops(state, shops) {
            state.shops = shops;
        },
        addStores(state, stores) {
            state.stores = stores;
        },
        addTags(state, tags) {
            state.tags = tags;
        }
    },
    getters: {
        hasPermissionForAction: state => (view, action) => {
            const userPermissions = state.user.permissions;
            const userRole = state.user.role ?? null;

            if (userRole && userRole === "superadmin") {
                return true;
            }

            let formattedView = view.replace("-", "_");

            if (userPermissions.hasOwnProperty(formattedView)) {
                if (action && userPermissions[formattedView].includes(action)) {
                    return true;
                }
            }

            return false;
        }
    }
});
